module.exports = __webpack_public_path__ + "static/img/team-share-popup.543a422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/popup/team-share-popup.png
// module id = 3HfC
// module chunks = 1